import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createSlots as _createSlots, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-884b667a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "clear"
}, null, -1));
const _hoisted_2 = {
  key: 0,
  class: "fileList"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_image = _resolveComponent("el-image");
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_progress = _resolveComponent("el-progress");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass($props.isButton ? 'uploadButton' : '')
  }, [_createVNode(_component_el_upload, {
    ref: "uploadRef",
    class: _normalizeClass(["avatar-uploader", $props.showFileList ? 'avatar-uploader-fileList' : $props.showImgList ? 'avatar-uploader-imgList' : '']),
    drag: "",
    multiple: $props.multiple,
    "show-file-list": false,
    limit: $props.limit,
    "before-upload": $options.handleBeforeUpload,
    "http-request": $options.requestFile,
    "on-remove": $options.removeFile,
    "on-exceed": $options.uploadExceed,
    "on-change": $options.uploadChange
  }, _createSlots({
    default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
      id: _ctx.uploadBtnId,
      class: "left"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.buttonText), 1)]),
      _: 1
    }, 8, ["id"]), [[_vShow, _ctx.loadProgress != 0 && _ctx.loadProgress != 100 && _ctx.progressFlag && $props.file_type == 'file']])]),
    _: 2
  }, [$props.isButton ? {
    name: "trigger",
    fn: _withCtx(() => [_createVNode(_component_el_button, {
      type: $props.buttonThemeType,
      plain: $props.plain,
      loading: _ctx.loadProgress != 0 && _ctx.loadProgress != 100 ? true : false
    }, {
      default: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent($props.icon), {
          style: {
            "width": "20px",
            "height": "20px"
          }
        }))]),
        _: 1
      }), _createTextVNode(" " + _toDisplayString($props.uploadTitle), 1)]),
      _: 1
    }, 8, ["type", "plain", "loading"])]),
    key: "0"
  } : {
    name: "trigger",
    fn: _withCtx(() => [$props.isShow && $props.showImgList && _ctx.fileList && _ctx.fileList.length > 0 && $props.file_type == 'images' ? (_openBlock(), _createElementBlock("div", {
      key: 0
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (item, index) => {
      return _openBlock(), _createElementBlock("li", {
        key: item.uid || index
      }, [_createVNode(_component_el_image, {
        src: item.url
      }, null, 8, ["src"]), _createVNode(_component_el_button, {
        size: "small",
        type: "info",
        icon: "Close",
        circle: "",
        onClick: _withModifiers($event => $options.handleManualRemove(item), ["stop"])
      }, null, 8, ["onClick"])]);
    }), 128)), _ctx.fileList && _ctx.fileList.length < $props.limit ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 0,
      class: "avatar-uploader-icon"
    }, {
      default: _withCtx(() => [_createVNode(_component_Plus)]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.fileList.length == 0 ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 1,
      class: "avatar-uploader-icon"
    }, {
      default: _withCtx(() => [_createVNode(_component_Plus)]),
      _: 1
    })) : _createCommentVNode("", true)]),
    key: "1"
  }]), 1032, ["class", "multiple", "limit", "before-upload", "http-request", "on-remove", "on-exceed", "on-change"]), _hoisted_1, _withDirectives(_createVNode(_component_el_progress, {
    percentage: _ctx.loadProgress
  }, null, 8, ["percentage"]), [[_vShow, _ctx.progressFlag && _ctx.loadProgress != 0 && _ctx.loadProgress != 100]]), $props.showFileList && _ctx.fileList && _ctx.fileList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: item.uid || index
    }, [_createTextVNode(_toDisplayString(item.filename_original || item.filename) + " ", 1), _createVNode(_component_el_button, {
      size: "small",
      type: "danger",
      icon: "Delete",
      onClick: _withModifiers($event => $options.handleManualRemove(item), ["stop"]),
      style: {
        "margin-left": "8px"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 删除 ")]),
      _: 2
    }, 1032, ["onClick"])]);
  }), 128))])) : _createCommentVNode("", true)], 2);
}